export default __webpack_public_path__ + "static/media/pathL2R.01310605.svg";